function bodyScrollLockHandler (isOpen) {
  if (typeof document === 'undefined') return
  var body = document.getElementsByTagName('body')
  if (isOpen) {
    body[0].style.overflow = 'hidden'
  } else {
    body[0].style.overflow = 'auto'
  }
}

module.exports = bodyScrollLockHandler



// WEBPACK FOOTER //
// ./src/global/js/bodyScrollLockHandler.js